import React,{ useState, useEffect } from "react";
import { 
    Card,
    Button, 
    ConfigProvider
} from 'antd';

import { 
    ArrowDownOutlined,
    ArrowUpOutlined,
    LaptopOutlined
} from '@ant-design/icons';

function PhoneProductCard( { 
    productData,
    handleAddToCart,
    activeProductId,
    addingToCart,
    isCartComponent,
    isLoading,
    isPlaceholder } ) {
    //console.log("addingToCart: ", addingToCart);
    //console.log("activeProductId: ", activeProductId);
    //console.log("isPlaceholder: ", isPlaceholder);
    //console.log("productData: ", productData.service_id);
    //console.log("productData: ", productData['product_attributes']['vendor-type']);

    let loading = ( addingToCart && ( activeProductId == productData.service_id ) ) ? true : false;
    let active = ( activeProductId == productData.service_id ) ? true : false;

    if( isPlaceholder ) {
        return <Card
            className="product-card phone-product-card"
            loading={ true }
            title={ '' } 
            bordered={ active }>
            
            <div className="product-card-content">
                <div className="product-card-detail-container"></div>
            </div>
        </Card>
    } else {
        let reccomendedClass = ( productData.service_id == 5166 ) ? 'recommended' : '';
        let supportedCountriesLink = ( productData.service_id == 5167 ) ? <a href="/support/supported-countries" target="_blank">View countries</a> : '';

        return (
            <Card
                className={ `product-card ${ reccomendedClass }  phone-product-card` }
                loading={ isLoading }
                hoverable
                title={
                    <div className="product-price">
                        <div className="product-title">{ productData.post_title }</div>
                        <div className="product-price-container">
                            <span className="dolla">$</span>
                            <span className="price">{ productData.service_price }</span>
                            <span className="duration">/mo</span>
                        </div>
                    </div>
                } 
                bordered={ active }
            >
            
                <div className="product-card-content">
                    <p style={{ marginBottom: '1rem' }}>
                        {productData.post_description} <br/>
                        <span style={{ display:'block', fontWeight: '500', marginTop:'0.5rem', textAlign:'right' }}>{ supportedCountriesLink }</span>
                    </p>
                    
                    <Button 
                        type="primary" 
                        className="ant-btn css-dev-only-do-not-override-xu9wm8 ant-btn-primary"
                        loading={ loading } 
                        onClick={ () => handleAddToCart( productData.service_id, productData.post_title )}>
                        Select Plan
                    </Button>
                </div>
            </Card>
        )
    }
}

export default PhoneProductCard